import { css, html, LitElement } from '~/lib/bn-lit-element';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-loading';
import './import-mapping-target-group';
import './import-csv-headers';

class ImportMappingContainer extends LitElement {
  static get properties() {
    return {
      availableHeaders: { type: Array },
      recordPreview: { type: Object },
      selectedHeaders: { type: Array },
      targetGroups: { type: Array },
      readonly: { type: Boolean },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      .well {
        padding: 1em;
      }
      .available-headers {
        min-width: 15em;
      }
      .main-container {
        display: flex;
      }
      .target-container {
        display: flex;
        flex-direction: column;
        width: 100%;
      }
      .separator-container {
        display: flex;
        padding: 0.1em;
        align-items: center;
        font-size: 3em;
        color: var(--blue-50);
      }
      import-mapping-target-group + import-mapping-target-group {
        margin-top: 1em;
      }
    `];
  }

  render() {
    return html`
      <div class="main-container">
        <div class="well available-headers">
          <h3>CSV Headers</h3>
          <import-csv-headers
            .headers="${this.availableHeaders}"
            .recordPreview="${this.recordPreview}"
            .selectedHeaders="${this.selectedHeaders}"
            ?draggable="${!this.readonly}"
          ></import-csv-headers>
        </div>
        <div class="separator-container">
          <bn-icon name="far fa-arrow-alt-right"></bn-icon>
        </div>
        <div class="well target-container">
          <h3>Target Fields</h3>
          ${this.targetGroups.map(({ name, targets }) => html`
            <import-mapping-target-group
              name="${name}"
              .targets="${targets}"
              .recordPreview="${this.recordPreview}"
              ?hide-group-name="${name === 'Customer'}"
              ?readonly="${this.readonly}"
            ></import-mapping-target-group>
          `)}
          <slot name="add-tag-action"></slot>
        </div>
      </div>
    `;
  }
}

window.customElements.define('import-mapping-container', ImportMappingContainer);
